import { Link } from 'react-router-dom'
import {ArrowRight} from 'lucide-react'
import PageHero from '@/components/PageHero'
import PageCTA from '@/components/PageCTA'
import SEO from '@/components/SEO'
import { institutions, images } from '@/content/site'

function Institutions() {
  return (
    <div>
      <SEO
        title="Ateliers d'expression artistique pour jeunes en institution | HeartCanvas"
        description="HeartCanvas propose des ateliers d'expression par l'art pour les jeunes accompagnés par des foyers, écoles et services de protection de la jeunesse en Suisse."
        path="/institutions"
      />
      <PageHero
        eyebrow={institutions.hero.eyebrow}
        title={institutions.hero.title}
      />

      <section className="px-6 md:px-10 -mt-4">
        <div className="max-w-7xl mx-auto">
          <img src={images.kidsPainting} alt="Atelier d'expression artistique pour jeunes en institution — peinture libre HeartCanvas" loading="lazy" className="w-full aspect-[16/8] object-cover" />
        </div>
      </section>

      {/* À QUI ÇA S'ADRESSE */}
      <section className="px-6 md:px-10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-12 md:gap-20">
          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#C0923F] mb-6">{institutions.aQui.eyebrow}</div>
            <h2 className="font-serif-display text-[28px] md:text-[44px] leading-[1.1] text-[#1F1B1D]">
              {institutions.aQui.title}
            </h2>
          </div>
          <div className="md:col-span-8 md:pt-4">
            {institutions.aQui.body.split('\n\n').map((para, i) => (
              <p key={i} className={`font-serif-display text-[18px] md:text-[20px] leading-[1.55] text-[#1F1B1D] max-w-3xl ${i > 0 ? 'mt-6' : ''}`}>
                {para}
              </p>
            ))}
          </div>
        </div>
      </section>

      {/* LE CONSTAT */}
      <section className="bg-[#EFE5EC] border-y border-[#DCC9D2] px-6 md:px-10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-12 md:gap-16 items-start">
          <div className="md:col-span-5">
            <img src="https://static.lumi.new/material/62/6252d293ab960ef7a5857da59c26744d.jpg" alt="Jeune en atelier d'expression artistique — espace d'accompagnement HeartCanvas pour institutions" loading="lazy" className="w-full aspect-[3/4] object-cover" />
          </div>
          <div className="md:col-span-7">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#C0923F] mb-6">{institutions.constat.eyebrow}</div>
            <h2 className="font-serif-display text-[28px] md:text-[44px] leading-[1.1] text-[#1F1B1D] mb-10">
              {institutions.constat.title}
            </h2>
            <div className="space-y-6 max-w-xl">
              <p className="font-serif-display text-[18px] md:text-[20px] leading-[1.6] text-[#1F1B1D]">
                {institutions.constat.paragraph1}
              </p>
              <p className="font-serif-display text-[18px] md:text-[20px] leading-[1.6] text-[#3A3236]">
                {institutions.constat.paragraph2}
              </p>
              <div className="pl-6 border-l-2 border-[#C0923F]">
                <p className="font-serif-display italic text-[18px] md:text-[20px] leading-[1.55] text-[#1F1B1D]">
                  {institutions.constat.quote}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CE QUE JE PROPOSE — DEUX PROPOSITIONS */}
      <section className="px-6 md:px-10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-12 gap-8 mb-16 md:mb-20">
            <div className="md:col-span-4">
              <div className="text-[11px] tracking-[0.3em] uppercase text-[#C0923F] mb-6">{institutions.proposition.eyebrow}</div>
            </div>
            <div className="md:col-span-8">
              <h2 className="font-serif-display text-[28px] md:text-[44px] leading-[1.1] text-[#1F1B1D]">
                {institutions.proposition.title}
              </h2>
            </div>
          </div>

          {/* CANEVAS DE TA VIE */}
          <div className="bg-[#F6EFF4] border border-[#DCC9D2] p-10 md:p-16 mb-20 md:mb-28">
            <h3 className="font-serif-display text-[26px] md:text-[36px] text-[#1F1B1D] leading-tight mb-8">
              {institutions.proposition.canevas.title}
            </h3>
            <div className="grid md:grid-cols-2 gap-8 md:gap-16">
              {institutions.proposition.canevas.body.split('\n\n').map((para, i) => (
                <p key={i} className="text-[17px] md:text-[18px] leading-[1.75] text-[#3A3236]">
                  {para}
                </p>
              ))}
            </div>
            <div className="mt-12 md:mt-16">
              <div className="relative w-full max-w-3xl mx-auto aspect-video overflow-hidden">
                <iframe
                  src="https://www.youtube.com/embed/SjAgM1NlxFY?autoplay=1&mute=1&loop=1&controls=0&playsinline=1&playlist=SjAgM1NlxFY&modestbranding=1&rel=0&showinfo=0&iv_load_policy=3"
                  title="Crée le canevas de ta vie — vidéo"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  className="absolute inset-0 w-full h-full border-0"
                />
              </div>
            </div>
          </div>

          {/* GESTE LIBRE */}
          <div>
            <div className="grid md:grid-cols-12 gap-12 md:gap-16 items-start">
              <div className="md:col-span-5">
                <h3 className="font-serif-display text-[26px] md:text-[36px] text-[#1F1B1D] leading-tight mb-6">
                  {institutions.proposition.gesteLibre.title}
                </h3>
                {institutions.proposition.gesteLibre.body.split('\n\n').map((para, i) => (
                  <p key={i} className={`text-[17px] md:text-[18px] leading-[1.75] text-[#3A3236] max-w-lg ${i > 0 ? 'mt-5' : ''}`}>
                    {para}
                  </p>
                ))}
              </div>
              <div className="md:col-span-7">
                <div className="grid grid-cols-2 gap-3">
                  {institutions.proposition.gesteLibre.photos.map((url, i) => (
                    <img
                      key={i}
                      src={url}
                      alt={`Atelier Geste libre HeartCanvas au CRAB de Bussigny — enfants de 5 à 12 ans (photo ${i + 1})`}
                      loading="lazy"
                      className="w-full aspect-square object-cover"
                    />
                  ))}
                </div>
                <p className="text-[13px] tracking-[0.05em] text-[#3A3236]/70 mt-3 text-center">
                  Atelier réalisé au CRAB à Bussigny — pour des enfants de 5 à 12 ans
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TARIFS */}
      <section className="bg-[#EFE5EC] border-y border-[#DCC9D2] px-6 md:px-10 py-20 md:py-28">
        <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-12 md:gap-20 items-center">
          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#C0923F] mb-6">{institutions.tarifs.eyebrow}</div>
            <h2 className="font-serif-display text-[28px] md:text-[44px] leading-[1.1] text-[#1F1B1D]">
              {institutions.tarifs.title}
            </h2>
          </div>
          <div className="md:col-span-8 md:pt-4">
            <p className="font-serif-display italic text-[18px] md:text-[20px] leading-[1.55] text-[#3A3236] max-w-xl mb-10">
              {institutions.tarifs.body}
            </p>
            <Link
              to="/contact"
              className="group inline-flex items-center gap-3 px-8 py-4 bg-[#9E3A5A] text-[#F6EFF4] text-[12px] tracking-[0.25em] uppercase hover:bg-[#7A2D46] transition-colors duration-500"
            >
              Prendre contact
              <ArrowRight size={14} className="transition-transform duration-500 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </section>

      {/* POURQUOI HEARTCANVAS */}
      <section className="bg-[#EFE5EC] border-y border-[#DCC9D2] px-6 md:px-10 py-24 md:py-32">
        <div className="max-w-5xl mx-auto">
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#C0923F] mb-6">{institutions.pourquoi.eyebrow}</div>
          <h2 className="font-serif-display text-[28px] md:text-[44px] leading-[1.1] text-[#1F1B1D] mb-12">
            {institutions.pourquoi.title}
          </h2>
          <div className="space-y-7">
            <p className="font-serif-display text-[18px] md:text-[20px] leading-[1.6] text-[#1F1B1D]">
              {institutions.pourquoi.paragraph1}
            </p>
            {institutions.pourquoi.paragraph2.split('\n\n').map((para, i) => (
              <p key={i} className="text-[17px] md:text-[18px] leading-[1.75] text-[#3A3236] max-w-2xl">
                {para}
              </p>
            ))}
          </div>
        </div>
      </section>

      {/* TRAVAILLONS ENSEMBLE */}
      <PageCTA
        eyebrow={institutions.travaillonsEnsemble.eyebrow}
        title={institutions.travaillonsEnsemble.title}
        body={institutions.travaillonsEnsemble.body}
        ctaLabel={institutions.travaillonsEnsemble.ctaLabel}
        ctaTo="/contact"
      />
    </div>
  )
}

export default Institutions
